import { useMemo } from 'react';
import { TDR } from 'tdr-common';
import {
	categorizeTables,
	TableCategories,
	TableCategoryCounts,
	TableSearchResultMap
} from '../categorizeTables';

export type { TableCategories, TableCategoryCounts, TableSearchResultMap };

export function useTableCategorization(
	searchResultTables: TDR.Table[],
	resultMap?: TableSearchResultMap
): { categories: TableCategories; counts: TableCategoryCounts } {
	return useMemo(() => categorizeTables(searchResultTables, resultMap), [searchResultTables, resultMap]);
}
